import { Cloudinary } from '@cloudinary/url-gen'
import { auto } from '@cloudinary/url-gen/qualifiers/quality'
import { fill } from '@cloudinary/url-gen/actions/resize'
import { quality } from '@cloudinary/url-gen/actions/delivery'

export const useCloudinaryUrls = () => {
  const cloudName = 'dttzs5jxf'
  const cld = new Cloudinary({
    cloud: {
      cloudName,
    },
  })

  /**
   * Generate thumbnail URL for images (no watermark)
   */
  const getImageThumbnailUrl = (media) => {
    return `https://res.cloudinary.com/${cloudName}/image/upload/c_limit,h_200,w_300/q_auto/r_15/${media.publicId}`
  }

  /**
   * Generate large image URL with watermark for modal view
   */
  const getImageLargeUrl = (media) => {
    return `https://res.cloudinary.com/${cloudName}/image/upload/c_limit,w_800/q_auto/l_swingmatch_logo/c_scale,h_50,w_50/o_70/e_anti_removal,fl_layer_apply,g_south_east,x_10,y_10/r_15/${media.publicId}`
  }

  /**
   * Generate video thumbnail URL
   */
  const getVideoThumbnailUrl = (publicId) => {
    return `https://res.cloudinary.com/${cloudName}/video/upload/c_fill,h_200,w_300/so_2.0/${publicId}.jpg`
  }

  /**
   * Generate video URL for large player using Cloudinary SDK
   */
  const getVideoLarge = (publicId) => {
    return cld.video(publicId)
      .resize(fill().width(600))
      .delivery(quality(auto()))
  }

  /**
   * Generate download URL with watermark (images) or without (videos)
   */
  const getDownloadUrl = (media) => {
    if (media.resourceType === 'image') {
      return `https://res.cloudinary.com/${cloudName}/image/upload/l_swingmatch_logo,g_south_east,o_70,w_100,h_100/fl_attachment/${media.publicId}.${media.format}`
    } else {
      return `https://res.cloudinary.com/${cloudName}/video/upload/fl_attachment/${media.publicId}.${media.format}`
    }
  }

  return {
    getImageThumbnailUrl,
    getImageLargeUrl,
    getVideoThumbnailUrl,
    getVideoLarge,
    getDownloadUrl,
  }
}
